import BigNumber from "bignumber.js";

import { useChains } from "../../../../../components/FetchConfig";
import {
  displayAmount,
  findDecimalByChainNameAndAsset,
  toDisplayTime
} from "../../../../../utils/helper";
import { useCreateSwapRequestContext } from "../../context";
import { getCommonDisplayDecimals } from "../../helpers/getCommonDisplayDecimals";
import { TabTypes } from "../../types";
import ContentRow from "../layout/ContentRow";

interface QuoteDetailsProps {
  fields: any;
  t: (key: string) => string;
  estimateField?: string;
  minMaxField?: string;
  estimateLabel?: string;
  minMaxLabel?: string;
  mode: TabTypes;
  amountCurrency?: string;
  amountFormulaString: string;
}

export const toQuoteDetailsAmount = (
  cryptoAmount: string,
  decimals: number
) => {
  if (!cryptoAmount || !decimals) {
    return "";
  }

  // convert to display amount + limit decimal place
  const result = BigNumber(cryptoAmount)
    .dividedBy(Math.pow(10, decimals))
    .decimalPlaces(getCommonDisplayDecimals(Number(decimals)), 1)
    .toFixed();

  return result;
};

const QuoteDetails = ({
  fields,
  t,
  estimateField = "estimateAmount",
  minMaxField = "getMin",
  estimateLabel = "estimateAmount",
  minMaxLabel = "getMin",
  mode,
  amountCurrency,
  amountFormulaString,
}: QuoteDetailsProps) => {
  const { filterFields } = useCreateSwapRequestContext();
  const { selectChainByPieces } = useChains();

  const { chain_type, chain_id } = selectChainByPieces({
    chain_name: filterFields.chainName,
  });

  const fromCurrencyDecimals = Number(
    findDecimalByChainNameAndAsset(
      String(chain_type),
      String(chain_id),
      filterFields.fromCurrency
    )
  );

  const toCurrencyDecimals = Number(
    findDecimalByChainNameAndAsset(
      String(chain_type),
      String(chain_id),
      filterFields.toCurrency
    )
  );

  const estimateDisplayAmount = fields[estimateField]
    ? toQuoteDetailsAmount(
        fields[estimateField],
        mode === TabTypes.EXACT_PAY ? toCurrencyDecimals : fromCurrencyDecimals
      )
    : "-";

  const minMaxDisplayAmount = fields[minMaxField]
    ? toQuoteDetailsAmount(
        fields[minMaxField],
        mode === TabTypes.EXACT_PAY ? toCurrencyDecimals : fromCurrencyDecimals
      )
    : "-";

  return (
    <div className="quote-details">
      <div className="details-title">{t("quoteDetails")}</div>
      <div className="content">
        <ContentRow title={t(estimateLabel)}>
          {estimateDisplayAmount && estimateDisplayAmount !== "-"
            ? `${displayAmount(estimateDisplayAmount, 0)} ${
                amountCurrency || ""
              }`
            : "-"}
        </ContentRow>
        <ContentRow title={t("exchangeRate")}>
          {fields.exchangeRate || "-"}
        </ContentRow>
        <ContentRow title={t(minMaxLabel)}>
          {minMaxDisplayAmount && minMaxDisplayAmount !== "-" ? (
            <div>
              <div>
                {displayAmount(minMaxDisplayAmount, 0)} {amountCurrency || ""}
              </div>
              <div>{amountFormulaString || ""}</div>
            </div>
          ) : (
            "-"
          )}
        </ContentRow>
        <ContentRow title={t("quotedTime")}>
          {toDisplayTime(fields.quotedTime) || "-"}
        </ContentRow>
      </div>
    </div>
  );
};

export default QuoteDetails;
